/**
 * Registers the editor's citation insertion into the thread composer layout
 * seam so the timeline's cite action can insert a chip from anywhere on the
 * surface. Rewritten for the Tiptap composer (ticket 3526); the comment
 * target state lives in the editor component itself.
 */

import { use, useEffect, type ReactNode } from "react";

import { useThreadComposerLayout } from "./chat/threadComposerLayoutContext";
import { ComposerCitationInsertContext } from "./ComposerCitationNode";

export function ComposerCitationProvider({ children }: { readonly children?: ReactNode }) {
  const insertCitation = use(ComposerCitationInsertContext);
  const { registerCitationEditor } = useThreadComposerLayout();
  useEffect(
    () =>
      registerCitationEditor((citation, sourceAnchor) => insertCitation(citation, sourceAnchor)),
    [insertCitation, registerCitationEditor],
  );
  return <>{children}</>;
}
